import { render, staticRenderFns } from "./AdmSettings.vue?vue&type=template&id=66f33d33&scoped=true&"
import script from "./AdmSettings.vue?vue&type=script&lang=js&"
export * from "./AdmSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdmSettings.vue?vue&type=style&index=0&id=66f33d33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f33d33",
  null
  
)

export default component.exports